import {IGridCell} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';
import {WSPIcons} from '@mintdata-wsp/resources/icons/WSPIcons';
import {IVisualDataStreamer} from '@mintdata-wsp/wsp/controllers/visualDesigner/visualData/VisualDataStreamer';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {Toolbar, ToolbarItem} from '@mintdata-wsp/wsp/ui/components/general/Toolbar';
import {AutoGridView, IAutoGridCommander} from '@mintdata-wsp/wsp/ui/components/grid/AutoGridView';
import {FrameColumnHeaderCell} from '@mintdata-wsp/wsp/ui/components/grid/cells/frame/FrameColumnHeaderCell';
import {PanelContentProps} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/layout/PanelView';
import {DebugKind} from '@mintdata-wsp/wsp/ui/views/visualDesigner/panels/debugData/DebugDataPanel';
import {DebugDataTopBar} from '@mintdata-wsp/wsp/ui/views/visualDesigner/panels/debugData/topbar/DebugDataTopBar';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {action} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./DebugDataView.less');
const cx = classnames.bind(styles);

export interface DebugPortViewProps extends PanelContentProps
{
    kind:DebugKind;
    label:string|null;
    streamer:IVisualDataStreamer;
}

@observer
export class DebugDataView extends React.Component<DebugPortViewProps, any>
{
    private readonly TOOLBAR_ITEMS =
    {
        WidenColumns: ToolbarItem.button(WSPIcons.visualDesigner.panels.debugData.AutosizeColumns, 'Resize columns to fit data'),
        RotateGrid: ToolbarItem.toggleButton(WSPIcons.visualDesigner.panels.debugData.TransposeGrid, 'Rotate grid'),

        // TODO fix for build dev
        // FilterColumns: ToolbarItem.popup(WSPIcons.visualDesigner.panels.debugData.EyeFilterColumns, 'Show / hide columns', this._renderColumnNames())
    };

    private _gridCommander:IAutoGridCommander = null;

    constructor(props:DebugPortViewProps)
    {
        super(props);
        this._init();
    }

    componentDidUpdate(prevProps: Readonly<DebugPortViewProps>, prevState: Readonly<any>, prevContext: any): void
    {
        this._init();
    }

    @action.bound
    private _init()
    {
        const {streamer} = this.props;
        this.TOOLBAR_ITEMS.RotateGrid.isToggledOn = streamer.getGridModel().isTransposed();
    }

    @bind
    private _renderColumnNames()
    {
        const {streamer} = this.props;
        const gridModel = streamer.getGridModel();

        const columns:IGridCell[] = gridModel.getColumnHeaders().getRow(0);

        return  <div>
                {
                    columns.map((column:IGridCell)=>
                    {
                        if( !(column instanceof FrameColumnHeaderCell) )
                            return null;

                        const aCell = column as FrameColumnHeaderCell;
                        return <div>{aCell.columnName}</div>;
                    })
                }
                </div>;
    }

    @action.bound
    private _onToolbarClick(item:ToolbarItem)
    {
        if( this.TOOLBAR_ITEMS.WidenColumns.isEqualTo(item) )
        {
            // const gridModel = this.props.streamer.getGridModel();
            // this._gridInstance.autoSizeColumnWidths(gridModel);
            // console.log('Resized cols: done');

            if( this._gridCommander )
                this._gridCommander.autosizeColumns();
        }
        else if( this.TOOLBAR_ITEMS.RotateGrid.isEqualTo(item) )
        {
            const gridModel = this.props.streamer.getGridModel();

            if( !gridModel.isTransposed() )
                gridModel.setIsTransposed(true);
            else
                gridModel.setIsTransposed(false);

            if( this._gridCommander )
                this._gridCommander.autosizeColumns();
        }
    }

    @bind
    private _renderTopBar()
    {
        return  <Row className={cx('topbar')}>
                    <Toolbar items={Object.values(this.TOOLBAR_ITEMS)} onClick={this._onToolbarClick}/>
                </Row>;
    }

    @bind
    private _onCommander(gridCommander:IAutoGridCommander)
    {
        this._gridCommander = gridCommander;
    }

    render()
    {
        const {streamer, label} = this.props;
        const gridModel = streamer.getGridModel();

        return  <div className={cx('debugPortView')}>

                    <DebugDataTopBar label={label}
                                     toolbarItems={Object.values(this.TOOLBAR_ITEMS)}
                                     streamer={streamer}
                                     onToolbarClick={this._onToolbarClick}
                    />

                    <AutoGridView className={cx('dataGrid')} gridModel={gridModel} onCommander={this._onCommander}/>

                </div>;
    }
}
